import { render, staticRenderFns } from "./AuditPembersihanLingkunganPage.vue?vue&type=template&id=6e9c6127&"
import script from "./AuditPembersihanLingkunganPage.vue?vue&type=script&lang=ts&"
export * from "./AuditPembersihanLingkunganPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
